import {
  load,
  AdminEnv,
  ClientPwaEnv,
  WeightControlEnv,
  GovDashPwaEnv,
  InspectEnv,
} from "@racoon/env";

const isAdminApp =
  typeof window !== "undefined" &&
  (window.location?.pathname?.includes("admin") || window.location?.hostname?.includes("admin"));

const isClientPwaApp =
  typeof window !== "undefined" &&
  (window.location?.pathname?.includes("client") ||
    window.location?.hostname?.includes("client") ||
    window.location?.hostname?.includes("local-client"));

const isWeightControlApp =
  typeof window !== "undefined" &&
  (window.location?.pathname?.includes("weight") ||
    window.location?.hostname?.includes("weight") ||
    window.location?.hostname?.includes("local-weight"));

const isGovDashApp =
  typeof window !== "undefined" &&
  (window.location?.pathname?.includes("govdash") ||
    window.location?.hostname?.includes("govdash") ||
    window.location?.hostname?.includes("local-govdash"));

const isInspectApp =
  typeof window !== "undefined" &&
  (window.location?.pathname?.includes("inspect") ||
    window.location?.hostname?.includes("inspect") ||
    window.location?.hostname?.includes("local-inspect"));

// Debug logging
if (typeof window !== "undefined") {
  console.log("Environment detection:", {
    isAdminApp,
    isClientPwaApp,
    isWeightControlApp,
    isGovDashApp,
    isInspectApp,
    hostname: window.location?.hostname,
    pathname: window.location?.pathname,
  });
}

const env = load(
  isAdminApp
    ? AdminEnv
    : isClientPwaApp
      ? ClientPwaEnv
      : isGovDashApp
        ? GovDashPwaEnv
        : isInspectApp
          ? InspectEnv
          : WeightControlEnv,
);

/**
 * Connect base URL for the app serving the current page.
 *
 * Lives apart from the transport so the bare refresh transport can reuse it
 * without importing the transport it must not go through.
 */
export const apiBaseUrl = (
  env.VITE_GO_API_URL ? env.VITE_GO_API_URL + "api/v2/" : "/api/v2/"
).replace(/\/$/, "");
